// src/components/Navigation/Navigation.js
import { useState } from 'react';
import { Menu } from 'lucide-react';
import MobileMenu from '../MobileMenu/MobileMenu';
import styles from './Navigation.module.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav className={styles.desktopNav}>
        <ul className={styles.navList}>
          <li><a onClick={() => scrollToSection('vision')} href="#vision">Vision</a></li>
          <li><a onClick={() => scrollToSection('work')} href="#work">Work</a></li>
          <li><a onClick={() => scrollToSection('why')} href="#why">Why</a></li>
          <li><a onClick={() => scrollToSection('team')} href="#team">Team</a></li>
          <li><a onClick={() => scrollToSection('journey')} href="#journey">Journey</a></li>
          <li><a onClick={() => scrollToSection('contact')} href="#contact">Contact</a></li>
        </ul>
      </nav>

      <button 
        className={styles.menuButton}
        onClick={() => setIsMenuOpen(true)}
      >
        <Menu size={24} />
      </button>

      <MobileMenu 
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        onNavigate={scrollToSection}
      />
    </>
  );
};

export default Navigation;